import * as React from 'react';
import { format } from 'date-fns';
import { get, isArray } from 'lodash';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { Link } from 'react-router-dom';

export default [
  {
    label: 'Název cyklu',
    field: 'label',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Od',
    field: 'from',
    type: ColumnType.TEXT,
    width: 100,
    mapper: value => (value ? format(value, 'DD. MM. YYYY') : '')
  },
  {
    label: 'Do',
    field: 'to',
    type: ColumnType.TEXT,
    width: 100,
    mapper: value => (value ? format(value, 'DD. MM. YYYY') : '')
  },
  {
    label: 'Zaměstnanci',
    field: 'employees',
    type: ColumnType.TEXT,
    width: 200,
    mapper: employees =>
      isArray(employees) ? employees.map(e => `${get(e, 'firstName')} ${get(e, 'lastName')}`).join(', ') : []
  },
  {
    label: 'Směna',
    field: 'shift.name',
    displayField: 'shift',
    type: ColumnType.TEXT,
    mapper: parent => get(parent, 'name'),
    width: 120
  },
  {
    label: 'Detail',
    field: 'id',
    type: ColumnType.JSX,
    width: 200,
    clickable: false,
    jsx: ({ row }) => (
      <div style={{ padding: 5 }}>
        <Button containerElement={<Link to={`/hr/shifts/cycles/detail/${row.id}`} />} label="Detail" />
      </div>
    )
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-shift-cycles/_shiftCyclesColumns.tsx